export default {
    root: {
        class: [
            // Shape
            'tw-rounded-md tw-shadow-lg tw-border',
            // Position
            'tw-absolute tw-left-0 tw-top-0 tw-mt-3',
            'tw-z-40 tw-transform tw-origin-center',
            '[&[data-p-popover-flipped="true"]]:tw-mb-3 [&[data-p-popover-flipped="true"]]:tw--mt-3',
            // Color
            'tw-bg-white dark:bg-gray-800',
            'tw-text-zinc-900',
            // Arrow
            'before:tw-absolute before:tw-w-0 before:tw--top-[0.49rem] before:tw-left-[--p-popover-arrow-left] before:tw-h-0 before:tw-border-transparent before:tw-border-solid before:tw-ml-[12px] before:tw-border-x-[9px] before:tw-border-b-[8px] before:tw-border-t-0 before:tw-border-b-gray-200 dark:before:tw-border-b-gray-700',
            'after:tw-absolute after:tw-w-0 after:tw--top-[0.45rem] after:tw-left-[--p-popover-arrow-left] after:tw-h-0 after:tw-border-transparent after:tw-border-solid after:tw-ml-[13px] after:tw-border-x-[8px] after:tw-border-b-[8px] after:tw-border-t-0 after:tw-border-b-white dark:after:tw-border-b-gray-800',
            // Flipped: Arrow
            '[&[data-p-popover-flipped="true"]]:before:tw--bottom-3 [&[data-p-popover-flipped="true"]]:before:tw-top-auto [&[data-p-popover-flipped="true"]]:before:tw-border-b-0 [&[data-p-popover-flipped="true"]]:before:tw-border-t-[10px] [&[data-p-popover-flipped="true"]]:before:tw-border-t-white dark:[&[data-p-popover-flipped="true"]]:before:tw-border-t-gray-700',
            '[&[data-p-popover-flipped="true"]]:after:tw--bottom-[0.54rem] [&[data-p-popover-flipped="true"]]:after:tw-top-auto [&[data-p-popover-flipped="true"]]:after:tw-border-b-0 [&[data-p-popover-flipped="true"]]:after:tw-border-t-[8px] [&[data-p-popover-flipped="true"]]:after:tw-border-t-white dark:[&[data-p-popover-flipped="true"]]:after:tw-border-t-gray-800',
        ],
    },
    content: {
        class: 'tw-p-2 tw-items-center tw-flex tw-font-sans md:tw-px-4 md:tw-py-3',
    },
    transition: {
        enterFromClass: 'tw-opacity-0 tw-scale-y-[0.8]',
        enterActiveClass: 'tw-transition-[transform,opacity] tw-duration-[120ms] tw-ease-[cubic-bezier(0,0,0.2,1)]',
        leaveActiveClass: 'tw-transition-opacity tw-duration-100 tw-ease-linear',
        leaveToClass: 'tw-opacity-0',
    },
};
